import {HttpClient} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {Users} from 'app/modal/users';
import {map, Observable, ReplaySubject, tap} from 'rxjs';

@Injectable({providedIn: 'root'})
export class UserService {
    private _httpClient = inject(HttpClient);
    private _user: ReplaySubject<Users> = new ReplaySubject<Users>(1);

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for user
     *
     * @param value
     */
    set user(value: Users) {
        // Store the value
        this._user.next(value);
    }

    get user$(): Observable<Users> {
        return this._user.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get the current signed-in user data
     */
    get(): Observable<Users> {
        return this._httpClient.get<Users>('api/common/user').pipe(
            tap((user) => {
                this._user.next(user);
            }),
        );
    }

    /**
     * Update the user
     *
     * @param user
     */
    update(user: Users): Observable<any> {
        return this._httpClient.patch<Users>('api/common/user', {user}).pipe(
            map((response) => {
                this._user.next(response);
            }),
        );
    }
}
